import * as React from 'react';
import Container from '../../../components/Container';
import Section from '../../../components/Section';
import styled from '../../../styled-components';
import { Candidate, Vacancy } from '../types';
import CreateVSponseButton from './CreateVSponseButton';
import VacancyBox from './VacancyBox';

interface VacancyProps {
    vacancies: Vacancy[];
    onCreate: () => void;
    onUpdate: (vacancy: Vacancy) => void;
    onDelete: (vacancy: Vacancy) => void;
    onAddCandidate: (vacancyId: string, firstname: string, lastname: string, email: string) => void;
    onUpdateCandidate: (vacancyId: string, candidate: Candidate) => void;
    onDeleteCandidate: (vacancyId: string, candidate: Candidate) => void;
    onInviteCandidate: (vacancyId: string, candidate: Candidate) => void;
    onShareWithHiringManager: (vacancy: Vacancy) => void;
    onAddVacancyLink: (vacancy: Vacancy) => void;
}

const Row = styled.div`
    display: flex;
    justify-content: space-between;
`;

class Vacancies extends React.Component<VacancyProps, any> {
    constructor(props: VacancyProps) {
        super(props);
    }

    public render() {
        return (
            <Section>
                <Container>
                    <Row>
                        <h1>V-Sponse</h1>
                        <CreateVSponseButton onClick={this.props.onCreate} />
                    </Row>
                    {this.props.vacancies.map((v) => (
                        <VacancyBox
                            key={v.id}
                            vacancy={v}
                            onUpdate={this.props.onUpdate}
                            onDelete={this.props.onDelete}
                            onAddCandidate={this.props.onAddCandidate}
                            onUpdateCandidate={this.props.onUpdateCandidate}
                            onDeleteCandidate={this.props.onDeleteCandidate}
                            onInviteCandidate={this.props.onInviteCandidate}
                            onShareWithHiringManager={this.props.onShareWithHiringManager}
                            onAddVacancyLink={this.props.onAddVacancyLink}
                        />
                    ))}
                </Container>
            </Section>
        );
    }
}

export default Vacancies;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/Vacancies.tsx